import { HTMLAttributes, forwardRef } from "react"
import { getButtonCss, ButtonStyleProps } from "../Button/ButtonStyles"
import { styled, StyleProps, cssHelper } from "../styles"

const StyledButtonLink = styled.a<HTMLAttributes<HTMLLinkElement>>(
  (props: StyleProps) =>
    cssHelper`
    ${{
      textDecoration: `none`,
      "&:hover": {
        cursor: `pointer`,
      },
      ...getButtonCss(props),
    }}
  `
)

export type ButtonLinkProps = ButtonStyleProps & React.ComponentPropsWithRef<typeof StyledButtonLink>

export const ButtonLink: React.FC<ButtonLinkProps> = forwardRef(
  ({ "data-testid": dataTestId, ...props }: ButtonLinkProps & { "data-testid": string }, forwardedRef) => (
    <StyledButtonLink ref={forwardedRef} data-testid={dataTestId} {...props} />
  )
)
